import { getPfmInstance } from '@shared/api';

export const CountryToAPI = {
  getCountryTo(townFromId?: number) {
    if (!townFromId) {
      throw new Error('town from id was not provided');
    }
    const pfm = getPfmInstance();
    return pfm.tourflow.getCountriesTo(townFromId);
  },
};
